import { getAccessToken } from '../../util/auth.util';
import { getCurrentCompanyId } from '../../util/token.util';

export namespace UploadUtil {
  export async function fileWithResponse(url: string, file: File) {
    const xhr = new XMLHttpRequest();

    xhr.open('POST', `${process.env.REACT_APP_API_BASE_URL}${url}`);
    xhr.setRequestHeader('Authorization', `Bearer ${getAccessToken()}`);
    xhr.setRequestHeader('x-company', getCurrentCompanyId() || '');

    const data = new FormData();
    data.append('file', file);
    data.append('name', file.name);
    data.append('type', file.type);

    try {
      const result = await new Promise<any>((resolve, reject) => {
        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve(xhr.response);
          } else {
            reject(new Error(xhr.statusText || 'Request failed'));
          }
        };
        xhr.onerror = () => reject(new Error('Network error'));
        xhr.send(data);
      });
      return JSON.parse(result);
    } catch (error) {
      throw error;
    }
  }
}
